// KMH: build a table of contents from H2s in the article body, and add anchor ids.
(function () {
  function init() {
    var content = document.getElementById('kmh-article-content');
    var toc = document.getElementById('kmh-toc');
    var list = document.getElementById('kmh-toc-list');
    if (!content || !toc || !list) return;

    var headings = content.querySelectorAll('h2');
    if (headings.length < 3) return; // only show TOC for longer posts

    headings.forEach(function (h, i) {
      var id = h.id || 'section-' + (i + 1);
      h.id = id;
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + id;
      a.textContent = h.textContent;
      li.appendChild(a);
      list.appendChild(li);
    });
    toc.hidden = false;
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();